import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { QrcodeService } from '../services/qrcode.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-url-result',
  templateUrl: './url-result.component.html',
  styleUrls: ['./url-result.component.css'],
  standalone: false,
})
export class URLResultComponent implements OnInit {

  qrdata: any[] = [];

  currentLang: string = 'ja';

  constructor(
    private qrcodeService: QrcodeService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.qrdata = this.qrcodeService.qrdata;
    this.currentLang = this.translate.currentLang;
  }

}
